"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_header_1 = __importDefault(require("@uswds/uswds/js/usa-header"));
const close_svg_1 = __importDefault(require("@uswds/uswds/img/usa-icons/close.svg"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const HeaderNavigation_1 = __importDefault(require("./HeaderNavigation/HeaderNavigation"));
const HeaderSecondaryNavigation_1 = __importDefault(require("./HeaderSecondaryNavigation/HeaderSecondaryNavigation"));
const HeaderTitle_1 = __importDefault(require("./HeaderTitle/HeaderTitle"));
const Search_1 = __importDefault(require("../../Search/Search"));
const HeaderComponent = ({ children, className, extended = false, ...props }) => {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // call USWDS's `on` function to initialize the component
        usa_header_1.default.on(containerEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_header_1.default.off(containerEl);
        };
    }, []);
    // handle child components
    const childComponents = (0, uswds_react_utils_1.flattenChildren)(react_1.Children.toArray(children));
    let navigationComponent;
    let searchComponent;
    let secondaryNavigationComponent;
    let titleComponent;
    for (const child of childComponents) {
        const componentType = (0, react_1.isValidElement)(child) ? child.type : undefined;
        switch (componentType) {
            case HeaderNavigation_1.default:
                navigationComponent = child;
                break;
            case HeaderSecondaryNavigation_1.default:
                secondaryNavigationComponent = child;
                break;
            case HeaderTitle_1.default:
                titleComponent = child;
                break;
            case Search_1.default:
                searchComponent = child;
                break;
            default:
                throw new Error(`Invalid child component '${componentType}' used in Header.`);
        }
    }
    const navNode = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: "usa-nav__close", type: "button", children: (0, jsx_runtime_1.jsx)("img", { src: close_svg_1.default, role: "img", alt: "close" }) }), navigationComponent && (0, react_1.cloneElement)(navigationComponent), extended ? ((0, jsx_runtime_1.jsxs)("div", { className: "usa-nav__secondary", children: [secondaryNavigationComponent &&
                        (0, react_1.cloneElement)(secondaryNavigationComponent), searchComponent && (0, react_1.cloneElement)(searchComponent)] })) : (searchComponent && (0, react_1.cloneElement)(searchComponent))] }));
    const headerNode = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "usa-navbar", children: [titleComponent && (0, react_1.cloneElement)(titleComponent), (0, jsx_runtime_1.jsx)("button", { className: "usa-menu-btn", type: "button", children: "Menu" })] }), (0, jsx_runtime_1.jsx)("nav", { "aria-label": "Primary navigation", className: "usa-nav", children: extended ? (0, jsx_runtime_1.jsx)("div", { className: "usa-nav__inner", children: navNode }) : navNode })] }));
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, uswds_react_utils_1.createClassString)('bah-uswds-header', className), ref: containerRef, ...props, children: [(0, jsx_runtime_1.jsx)("div", { className: "usa-overlay" }), (0, jsx_runtime_1.jsx)("header", { className: (0, uswds_react_utils_1.createClassString)('usa-header', extended ? 'usa-header--extended' : 'usa-header--basic'), children: extended ? (headerNode) : ((0, jsx_runtime_1.jsx)("div", { className: "usa-nav-container", children: headerNode })) })] }));
};
const Header = Object.assign(HeaderComponent, {
    Navigation: HeaderNavigation_1.default,
    SecondaryNavigation: HeaderSecondaryNavigation_1.default,
    Title: HeaderTitle_1.default
});
exports.default = Header;
